import React, { useState } from 'react';
import { Theme } from '../../../Enums/Theme.enum';
import Button from '../../../Components/Button/Button';
import BaseModal from '../../Base/Components/BaseModal/BaseModal';
import NotificationsSetup from './NotificationsSetup';

const NotificationsSetupButton: React.FC = () => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<Button
				title='component.notificationsSetupButton.title'
				theme={Theme.BLUE}
				onClick={() => setIsOpen(true)}
				className='mt-4'
			/>
			<BaseModal
				title='component.notificationsSetupButton.title'
				isOpen={isOpen}
				onClose={() => setIsOpen(false)}>
				<NotificationsSetup />
			</BaseModal>
		</>
	);
};

export default NotificationsSetupButton;
